import type { HighCostZipCode } from "../../hooks/react-query/backOffice/useHighCostZipCodeList";

export const mockHighCostZipCodeList: HighCostZipCode[] = [
  {
    id: 1,
    zipCodeType: 1,
    zipCodeTypeName: "Single",
    lowZipCode: "86510",
    highZipCode: null,
    rateType: 1,
    rateTypeName: "Flat",
    sequenceId: 1,
    rate: 60.0,
    minimumAmt: null,
    scope: "Both",
    appliesTo: "Both",
    state: "AZ",
    stateName: "Arizona",
  },
  {
    id: 2,
    zipCodeType: 1,
    zipCodeTypeName: "Single",
    lowZipCode: "86510",
    highZipCode: null,
    rateType: 1,
    rateTypeName: "Flat",
    sequenceId: 2,
    rate: 60.0,
    minimumAmt: null,
    scope: "Interstate",
    appliesTo: "Both",
    state: "AZ",
    stateName: "Arizona",
  },
  {
    id: 3,
    zipCodeType: 2,
    zipCodeTypeName: "Range",
    lowZipCode: "86510",
    highZipCode: "86515",
    rateType: 3,
    rateTypeName: "Surcharge",
    sequenceId: 3,
    rate: 69,
    minimumAmt: null,
    scope: "Both",
    appliesTo: "Pickup",
    state: "AZ",
    stateName: "Arizona",
  },
  {
    id: 4,
    zipCodeType: 1,
    zipCodeTypeName: "Single",
    lowZipCode: "86510",
    highZipCode: null,
    rateType: 1,
    rateTypeName: "Flat",
    sequenceId: 4,
    rate: 60.0,
    minimumAmt: null,
    scope: "Both",
    appliesTo: "Both",
    state: "AZ",
    stateName: "Arizona",
  },
  {
    id: 5,
    zipCodeType: 1,
    zipCodeTypeName: "Single",
    lowZipCode: "86510",
    highZipCode: null,
    rateType: 2,
    rateTypeName: "Rate per 100lbs",
    sequenceId: 5,
    rate: 60.0,
    minimumAmt: 40.0,
    scope: "Interstate",
    appliesTo: "Delivery",
    state: "AZ",
    stateName: "Arizona",
  },
  {
    id: 6,
    zipCodeType: 1,
    zipCodeTypeName: "Single",
    lowZipCode: "86510",
    highZipCode: null,
    rateType: 1,
    rateTypeName: "Flat",
    sequenceId: 6,
    rate: 60.0,
    minimumAmt: null,
    scope: "Both",
    appliesTo: "Both",
    state: "AZ",
    stateName: "Arizona",
  },
  {
    id: 7,
    zipCodeType: 1,
    zipCodeTypeName: "Single",
    lowZipCode: "86510",
    highZipCode: null,
    rateType: 1,
    rateTypeName: "Flat",
    sequenceId: 7,
    rate: 60.0,
    minimumAmt: null,
    scope: "Interstate",
    appliesTo: "Pickup",
    state: "AZ",
    stateName: "Arizona",
  },
  {
    id: 8,
    zipCodeType: 1,
    zipCodeTypeName: "Single",
    lowZipCode: "86510",
    highZipCode: null,
    rateType: 3,
    rateTypeName: "Surcharge",
    sequenceId: 8,
    rate: 69,
    minimumAmt: null,
    scope: "Both",
    appliesTo: "Both",
    state: "AZ",
    stateName: "Arizona",
  },
  {
    id: 9,
    zipCodeType: 1,
    zipCodeTypeName: "Single",
    lowZipCode: "86510",
    highZipCode: null,
    rateType: 1,
    rateTypeName: "Flat",
    sequenceId: 9,
    rate: 60.0,
    minimumAmt: null,
    scope: "Interstate",
    appliesTo: "Delivery",
    state: "AZ",
    stateName: "Arizona",
  },
  {
    id: 10,
    zipCodeType: 1,
    zipCodeTypeName: "Single",
    lowZipCode: "86510",
    highZipCode: null,
    rateType: 1,
    rateTypeName: "Flat",
    sequenceId: 10,
    rate: 60.0,
    minimumAmt: null,
    scope: "Both",
    appliesTo: "Both",
    state: "AZ",
    stateName: "Arizona",
  },
];
